<div class="position-absolute top-0 end-0 p-3 z-index-max">
  <ul class="list-unstyled m-0 p-0">
    <li>
      <app-notificacoes-gerais-chat *ngIf="permissoesUsuario.includes('acessar_chat_premoplan')"></app-notificacoes-gerais-chat>
    </li>
  </ul>
</div>
